// Google Analytics 4 event tracking utility
// All custom events for Destrier are defined and fired from here.
// GA4 only loads after user gives cookie consent.

const GA_ID = 'G-6NHJQRHSE1';

let gaInitialized = false;

export function initGA() {
  if (gaInitialized) return;
  gaInitialized = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
}

export function getConsent() {
  return localStorage.getItem('destrier_cookie_consent');
}

export function setConsent(value) {
  localStorage.setItem('destrier_cookie_consent', value);
  if (value === 'accepted') initGA();
}

// Auto-init if user already accepted in a previous session
if (getConsent() === 'accepted') initGA();

const gtag = (...args) => {
  if (typeof window !== 'undefined' && window.gtag && gaInitialized) {
    window.gtag(...args);
  }
};

// ── Acquisition ──
export const trackCtaClick = (ctaName, location) =>
  gtag('event', 'cta_click', { cta_name: ctaName, location });

export const trackPricingSectionView = () =>
  gtag('event', 'pricing_section_view');

export const trackFaqSectionView = () =>
  gtag('event', 'faq_section_view');

// ── Activation ──
export const trackWaitlistSignup = (position) =>
  gtag('event', 'waitlist_signup', { position });

export const trackSignup = (method = 'email') =>
  gtag('event', 'sign_up', { method });

export const trackLogin = (method = 'email') =>
  gtag('event', 'login', { method });

export const trackUsernameEntered = (username) =>
  gtag('event', 'username_entered', { chess_username: username });

export const trackAnalysisStarted = (username) =>
  gtag('event', 'analysis_started', { chess_username: username });

export const trackAnalysisCompleted = (username, archetype) =>
  gtag('event', 'analysis_completed', { chess_username: username, archetype });

export const trackAnalysisFailed = (username, errorMsg) =>
  gtag('event', 'analysis_failed', { chess_username: username, error: errorMsg });

export const trackFirstReportViewed = (username) =>
  gtag('event', 'first_report_viewed', { chess_username: username });

// ── Engagement ──
export const trackDashboardTabClick = (tabName) =>
  gtag('event', 'dashboard_tab_click', { tab: tabName });

export const trackArchetypeViewed = (archetype) =>
  gtag('event', 'archetype_viewed', { archetype });

export const trackGameViewerOpened = (opening, result) =>
  gtag('event', 'game_viewer_opened', { opening, result });

export const trackGameNavigated = () =>
  gtag('event', 'game_navigated');

export const trackTimeOnReport = (seconds) =>
  gtag('event', 'time_on_report', { seconds });

export const trackScrollDepthReport = (percent) =>
  gtag('event', 'scroll_depth_report', { percent });

// ── Sharing ──
export const trackShareClick = (platform) =>
  gtag('event', 'share_click', { platform });

// ── Retention ──
export const trackReturnVisit = () =>
  gtag('event', 'return_visit');

export const trackSecondAnalysis = (username) =>
  gtag('event', 'second_analysis', { chess_username: username });

export const trackSettingsChanged = (setting) =>
  gtag('event', 'settings_changed', { setting });

// ── Revenue (future — Stripe) ──
export const trackPricingCardClick = (tier) =>
  gtag('event', 'pricing_card_click', { tier });

export const trackUpgradeClicked = (tier) =>
  gtag('event', 'upgrade_click', { tier });

// ── Friction ──
export const trackErrorDisplayed = (page, errorMsg) =>
  gtag('event', 'error_displayed', { page, error: errorMsg });

export const trackAnalysisTimeout = (username) =>
  gtag('event', 'analysis_timeout', { chess_username: username });

export const trackPageExit = (page) =>
  gtag('event', 'page_exit', { page });
